/**=========================================================
 * Module: field.js
 * Field Controller
 =========================================================*/

App.controller('FieldController',
  ['$rootScope', '$scope', '$state', '$translate', '$window', '$localStorage', '$timeout', 'toggleStateService', 'Restangular', 'ngDialog', 'LocalRestangular', '$sce', '$interval', 'DataService', '$http',
  function($rootScope, $scope, $state, $translate, $window, $localStorage, $timeout, toggle, R, ngDialog, LR, $sce, $interval, D, $http) {
    "use strict";
    
    if(!$scope.field.column) 
        $scope.field.column = 12;
    
    if($scope.field.labelColumn===0) $scope.field.labelColumn = "0";
    
    if($scope.field.column==12){
        $scope.field.labelColumn = $scope.field.labelColumn || 2;
        $scope.field.inputColumn = $scope.field.inputColumn || 10;
    } else if($scope.field.column==6){
        $scope.field.labelColumn = $scope.field.labelColumn || 6;
        $scope.field.inputColumn = $scope.field.inputColumn || 6;
    } else if($scope.field.column==4){
        $scope.field.labelColumn = $scope.field.labelColumn || 6;
        $scope.field.inputColumn = $scope.field.inputColumn || 6;
    } 
    
    $scope.columnClass = 'col-lg-' + $scope.field.column;
    $scope.labelColumnClass = 'col-lg-' + $scope.field.labelColumn + ($scope.field.labelColumn==1 || $scope.field.labelAlign=='left' ? ' label-left' : '');
    $scope.inputColumnClass = 'col-lg-' + $scope.field.inputColumn;

    if($scope.field.noSpace){
        $scope.columnClass += ' noSpace'
    }

      
    $scope.setSgAs = function(v){
        if(!$scope.form.model.notSupOf) $scope.form.model.notSupOf = []
        if($scope.form.model.sgAs[v]=='SUPERUSER'){
            if($scope.form.model.notSupOf.indexOf(v)>=0){
                $scope.form.model.notSupOf.splice($scope.form.model.notSupOf.indexOf(v), 1)
            }
        } else if($scope.form.model.sgAs[v]=='USER'){
            if($scope.form.model.notSupOf.indexOf(v)<0){
                $scope.form.model.notSupOf.push(v)
            }
        }
    }

    $scope.selectUnselectAll = function(){
        if($scope.form.model[$scope.field.name] && $scope.form.model[$scope.field.name].length == $scope.field.data.length){
            $scope.form.model[$scope.field.name] = [];
        } else {
            $scope.form.model[$scope.field.name] = $scope.field.data.map(function(item) { 
                return item[$scope.field.valueField]; 
            });
        }
        
    };

    $scope.closeTooltip = function(){
        $rootScope.closeTooltipByEvent($rootScope.currentPage, $scope.field.tooltip.name);
    }

    $scope.showInstructions = function(instructionsText){
        $scope.instructionsText = instructionsText;
        ngDialog.open({
            template: '/app/views/entities/instructions.html',
            className: 'ngdialog-theme-default ngdialog-theme-large',
            scope: $scope
        })
    }

    $scope.selectUnselectAllSuppliers = function(){
        var hasFake = $scope.field.data.filter(function(o) { return o.fake; }).length;
        if($scope.form.model[$scope.field.name] && $scope.form.model[$scope.field.name].length == $scope.field.data.length - hasFake){
            $scope.form.model[$scope.field.name] = [];
        } else {
            $scope.form.model[$scope.field.name] = $scope.field.data.map(function(item) { 
                return !item.fake ? item[$scope.field.valueField] : null; 
            }).filter(function(item) { return item!=null; });

        }
    }

    if($scope.field.type=='datetime'){
        var m = moment($scope.form.model[$scope.field.name + 'WithTime']);
        if($scope.field.hasTime && $scope.form.model[$scope.field.name+'HasTime']){
            $scope.form.model[$scope.field.name + '_Time'] = m.hours()*3600 + m.minutes()*60 + m.seconds();
        }
        if($scope.form.model[$scope.field.name]) {
            $scope.form.model[$scope.field.name] = moment(m.format('YYYY-MM-DD')).valueOf();
        }
        
    }

    

    if($scope.field.type=='monthyear'){
        $scope.form.model[$scope.field.name + '_year'] = $scope.form.model[$scope.field.name] ? $scope.form.model[$scope.field.name].substr(0, 4) : '';
        $scope.form.model[$scope.field.name + '_month'] = $scope.form.model[$scope.field.name] ? $scope.form.model[$scope.field.name].substr(4) : '';

        $scope.months = [{value:'-',label:'-'}];
        for(var i=0; i<12; i++){
            $scope.months.push({
                value: i+1,
                label: moment().month(i).format('MMMM')
            })
        }
        $scope.years = ['-'];
        var now = new Date().getFullYear();
        for(var i=2015; i<=now; i++){
            $scope.years.push(i);
        }

        $scope.onchangeMY = function(){
            if(($scope.form.model[$scope.field.name + '_year']=='-' || !$scope.form.model[$scope.field.name + '_year']) 
                && $scope.form.model[$scope.field.name + '_month'] && $scope.form.model[$scope.field.name + '_month']!='-'){
                $scope.form.model[$scope.field.name + '_year'] = $scope.field.defaultYear || '-';
            }
            if(($scope.form.model[$scope.field.name + '_month']=='-' || !$scope.form.model[$scope.field.name + '_month']) 
                && $scope.form.model[$scope.field.name + '_year'] && $scope.form.model[$scope.field.name + '_year']!='-'){
                $scope.form.model[$scope.field.name + '_month'] = $scope.field.defaultMonth || '-';
            }
            if($scope.form.model[$scope.field.name + '_year']=='-'){ $scope.form.model[$scope.field.name + '_year'] = '' }
            if($scope.form.model[$scope.field.name + '_month']=='-'){ $scope.form.model[$scope.field.name + '_month'] = '' }
            if($scope.form.model[$scope.field.name + '_year'] && $scope.form.model[$scope.field.name + '_month']){
                $scope.form.model[$scope.field.name] = $scope.form.model[$scope.field.name + '_year'] + ('0' + $scope.form.model[$scope.field.name + '_month']).substr(-2);
            } else {
                $scope.form.model[$scope.field.name] = '';
            }
            if($scope.field.onchange){
                $scope.field.onchange();
            }
        }
    }

    $scope.updateModel = function(newModel){
        $scope.form.model = Object.assign($scope.form.model, newModel)
    }

    $scope.browseFolder = function(startingPath, withFiles, limit){
        $scope.field.selecting = true
        $scope.browsePath = startingPath || $rootScope.localServer.path
        $scope.browseElements = []
        $scope.browsingFiles = withFiles
        $scope.browseLimit = limit
        $scope.browse = function(dir){
            if(dir=='..') $scope.browsePath = $scope.browsePath.substring(0, $scope.browsePath.lastIndexOf(CONFIG.folderSeparator))
            else if(dir) $scope.browsePath += CONFIG.folderSeparator + dir
            LR.one('fs', $scope.browsePath).get()
                .then(function(response){
                    $scope.browseElements = response.dirs
                    if(withFiles)$scope.browseElements = $scope.browseElements.concat(response.files)
                }).catch(console.error)
        }
        $scope.browse();
        ngDialog.open({
            template: '/app/views/entities/folder-browsepopup.html',
            className: 'ngdialog-theme-large',
            scope: $scope,
            cache: false
        })
        $scope.selectedElements = []
        $scope.addElement = function(el){
            if(el.size===undefined){
                $scope.$emit('$addFolderToFileList', { name: $scope.browsePath + CONFIG.folderSeparator + el.name })
            } else {
                $scope.$emit('$addFileToFileList', { name: $scope.browsePath + CONFIG.folderSeparator + el.name })
            }
            ngDialog.close()
        }
        $scope.toggleElement = function(el){
            el.selected = !el.selected
            if(el.selected){
                $scope.selectedElements.push(el)
            } else {
                $scope.selectedElements.splice($scope.selectedElements.indexOf(el), 1)
            }
        }
        $scope.addSelectedElements = function(){
            for(var i in $scope.selectedElements){
                var el = $scope.selectedElements[i]
                if(el.size===undefined){
                    $scope.$emit('$addFolderToFileList', { name: $scope.browsePath + CONFIG.folderSeparator + el.name })
                } else {
                    $scope.$emit('$addFileToFileList', { name: $scope.browsePath + CONFIG.folderSeparator + el.name })
                }
            }
            ngDialog.close()
        }
    }

    $scope.removeElement = function(el){
        $scope.$emit('$removeElementFromFileList', el)
    }

    if($scope.field.selective){
        $scope.$watch('field.selecting', function(){
            if($scope.field.selecting){
                for(var i=0; i<$scope.form.fields.length; i++){
                    var f = $scope.form.fields[i]
                    if(f.selective && f.selecting && f.name!=$scope.field.name){
                        f.selecting = false
                    }
                }
                $scope.form.selectingField = $scope.field.name
            } else {
                let isThereOneSelecting = false
                for(var i=0; i<$scope.form.fields.length; i++){
                    var f = $scope.form.fields[i]
                    if(f.selective && f.selecting && f.name!=$scope.field.name){
                        isThereOneSelecting = true
                    }
                }
                if(!isThereOneSelecting){
                    for(var i=0; i<$scope.form.fields.length; i++){
                        var f = $scope.form.fields[i]
                        if(f.selective && !f.selecting && f.name!=$scope.field.name){
                            f.selecting = true
                            $scope.form.selectingField = $scope.field.name
                            break
                        }
                    }
                }
            }
        })
    }

    if($scope.field.rules){
        $scope.moveRule = function(direction, index){
            let rules = $scope.field.rules
            if(direction=='up' && index>0){
                let temp = rules[index-1]
                rules[index-1] = rules[index]
                rules[index] = temp
            }
            if(direction=='down' && index<rules.length-1){
                let temp = rules[index+1]
                rules[index+1] = rules[index]
                rules[index] = temp
            }
            $scope.field.rules = rules
        }

        $scope.openRule = function(rule){
            var scope = $scope.$new();
            scope.rule = rule
            scope.testRuleSource = ''
            scope.testRuleTarget = ''
            scope.testRuleTimeout = null
            scope.testRule = function(){
                if(scope.testRuleTimeout){
                    $timeout.cancel(scope.testRuleTimeout)
                }
                scope.testRuleTimeout = $timeout(function() {
                    LR.one('aqrator', '').customPOST({
                        aqrator: {
                            action: 'xliff',
                            data: {
                                testRule: rule.name,
                                source: rule.testSource,
                                target: rule.testTarget
                            }
                        }
                    }).then(function(resp){
                        rule.testTransform = resp.transformed
                    }).catch(console.error)
                }, 500)
            }
            ngDialog.open({
                template: '/app/views/entities/aqrator-xliffrule.html',
                className: 'ngdialog-theme-large',
                scope: scope,
                cache: false
            })
        }

        $scope.selectRules = function(s){
            for(var i in $scope.field.rules){
                if(s===true){
                    $scope.field.rules[i].active = true
                } else if(s===false){
                    $scope.field.rules[i].active = false
                }
            }
        }
    }

    $scope.field.toggleShowAddLink = function($event){
        $event.stopPropagation();
	    $event.preventDefault();
        $scope.field.showAddLink = !$scope.field.showAddLink
        if($scope.field.showAddLink){
            angular.element('.file-upload-result-alert').css('display', 'none')
        }
    }

    $scope.field.uploadAsLink = function(){
        if($scope.field.addLinkSaving) return
        var url;
        $scope.field.addLinkError = null
        try {
            if($scope.field.addLink && $scope.field.addLink.indexOf('http')!==0) {
                $scope.field.addLink = 'http://' + $scope.field.addLink
            }
            url = new URL($scope.field.addLink);
            if(url.protocol!=='http:' && url.protocol!=='https:'){
                $scope.field.addLinkError = 'labels.UPLOADASLINKINVALIDURL'
            }
        } catch (_) {
            $scope.field.addLinkError = 'labels.UPLOADASLINKINVALIDURL'
        }
        $scope.field.addLinkSaving = false
        var saveLink = function(){
            $scope.field.addLinkSaving = true
            D.save('file', { 
                entityType: $scope.form.type, 
                entityId: $scope.form.model.id || $scope.form.model.tempId, 
                field: $scope.field.name,
                type: '',
                size: 0,
                url: $scope.field.addLink,
                instructions: $scope.field.addLinkInfo
            }).then(function(resp){
                $scope.field.addLinkSaving = false
                $scope.field.addLink = ''
                $scope.field.addLinkInfo = ''
                $scope.field.addLinkError = null
                $scope.field.showAddLink = false;
                var fn = function(s, r){
                    angular.element(document.getElementById('upload-link_'+s.field.name+'_'+(s.form.model.id || s.form.model.tempId)))
                            .triggerHandler('$uploadedAsLink', r);
                        
                }
                fn($scope, resp)
            }).catch(function(err){
                $scope.field.addLinkSaving = false
                $scope.field.addLinkError = err
            })
        }

        if(!$scope.field.addLinkError){
            $scope.field.addLinkSaving = true
            D.call('checkUrl', 'put', '', { url: $scope.field.addLink })
                .then(function(response){
                    if(response.status==404){
                        $scope.field.addLinkSaving = false
                        $scope.field.addLinkError = 'labels.UPLOADASLINKNOTFOUNDURL'
                    } else {
                        saveLink()
                    }
                }).catch(function(err){
                    saveLink()
                })
            
        }

    }

    $scope.saveFileInstructions = function(file){
        file.action = 'SaveInstructions'
        file.instructionsError = false
        file.instructions = angular.element('#I_' + file.id).text()
        D.save('file', file).then(function(response){
            file.editInstructions = false
            file.action = ''
        }).catch(function(err){
            file.instructionsError = true
        })
    }

    $scope.$on('$destroy', function() {
        /*if(interval) { 
            $interval.cancel(interval);
            interval = null;
        }*/
      });

    $scope.trustAction = function (actionURL) {
        return $sce.trustAsResourceUrl(actionURL);
    };
    
    $scope.setFileLang = function(file){
        file.action = 'SetFileLang'
        D.save('file', file).then(function(response){
            if(!response) file.lang = null
            file.action = ''
        }).catch(function(err){
            file.lang = null
        })
    }
      
  }
  ]);